/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RIGHT {
  MANAGE_USERS = 'manage_users',
  MANAGE_CHANGE_LOGS = 'manage_change_logs',
  CREATE_GAMES = 'create_games',
  READ_GAMES = 'read_games',
  UPDATE_GAMES = 'update_games',
  DELETE_GAMES = 'delete_games',
  UPDATE_GAME_IMAGES = 'update_game_images',
  READ_GAMES_VAIX = 'read_games_vaix',
  MANAGE_GAME_CATEGORIES = 'manage_game_categories',
  MANAGE_GAMES_IN_BONUS_CATEGORIES_ONLY = 'manage_games_in_bonus_categories_only',
  READ_GAME_TO_CATEGORIES = 'read_game_to_categories',
  MANAGE_GAME_TO_CATEGORIES = 'manage_game_to_categories',
  MANAGE_CATEGORY_LOCALE_SETTINGS = 'manage_category_locale_settings',
  UPLOAD_IMAGE_CATEGORY = 'upload_image_category',
  MANAGE_PROVIDER_SETTINGS = 'manage_provider_settings',
  MANAGE_AGGREGATORS = 'manage_aggregators',
  READ_FEED_READER_LOGS = 'read_feed_reader_logs',
  READ_CHANGELOGS = 'read_changelogs',
  MANAGE_API_KEYS = 'manage_api_keys',
  MAKE_PROVIDER_API_CALL = 'make_provider_api_call',
  MANAGE_GAME_SETTINGS = 'manage_game_settings',
  MANAGE_CATEGORY_SETTINGS = 'manage_category_settings',
  READ_GAME_OF_WEEK = 'read_game_of_week',
  CREATE_GAME_OF_WEEK = 'create_game_of_week',
  UPDATE_GAME_OF_WEEK = 'update_game_of_week',
  DELETE_GAME_OF_WEEK = 'delete_game_of_week',
  READ_DISABLED_OWNERS = 'read_disabled_owners',
  MANAGE_DISABLED_OWNERS = 'manage_disabled_owners',
  READ_CATALOG_AGGREGATORS = 'read_catalog_aggregators',
  MANAGE_CATALOG_AGGREGATORS = 'manage_catalog_aggregators',
  READ_CATALOG_PROVIDERS = 'read_catalog_providers',
  MANAGE_CATALOG_PROVIDERS = 'manage_catalog_providers',
  READ_CURRENCIES = 'read_currencies',
  MANAGE_CURRENCIES = 'manage_currencies',
  MANAGE_PROVIDERS_DISCOUNTS = 'manage_providers_discounts',
  MANAGE_COMMENTS = 'manage_comments',
  MANAGE_COLLECTIONS = 'manage_collections',
  MANAGE_TENANT_SETTINGS = 'manage_tenant_settings',
  MANAGE_GAME_TAGS = 'manage_game_tags',
}
